export const metricType = {
    COUNT: "count",
    TIME: "time"
};



// WEBPACK FOOTER //
// ./src/components/util/enums.js